/* X3 Coupon Form — submit + success-state swap */
(function () {
  'use strict';

  var CAMPAIGN_ID = '123';
  var SIGN_SECRET = 'FH3yBh1kIewOlhG5';
  var API_URL_FALLBACK = 'https://aladdin-api.xigmi.com/';

  function md5(input) {
    function add32(a, b) { return (a + b) & 0xFFFFFFFF; }
    function cmn(q, a, b, x, s, t) { return add32(((add32(add32(a, q), add32(x, t)) << s) | (add32(add32(a, q), add32(x, t)) >>> (32 - s))), b); }
    function ff(a, b, c, d, x, s, t) { return cmn((b & c) | ((~b) & d), a, b, x, s, t); }
    function gg(a, b, c, d, x, s, t) { return cmn((b & d) | (c & (~d)), a, b, x, s, t); }
    function hh(a, b, c, d, x, s, t) { return cmn(b ^ c ^ d, a, b, x, s, t); }
    function ii(a, b, c, d, x, s, t) { return cmn(c ^ (b | (~d)), a, b, x, s, t); }

    function md5cycle(state, k) {
      var a = state[0], b = state[1], c = state[2], d = state[3];

      a = ff(a, b, c, d, k[0], 7, -680876936); d = ff(d, a, b, c, k[1], 12, -389564586);
      c = ff(c, d, a, b, k[2], 17, 606105819); b = ff(b, c, d, a, k[3], 22, -1044525330);
      a = ff(a, b, c, d, k[4], 7, -176418897); d = ff(d, a, b, c, k[5], 12, 1200080426);
      c = ff(c, d, a, b, k[6], 17, -1473231341); b = ff(b, c, d, a, k[7], 22, -45705983);
      a = ff(a, b, c, d, k[8], 7, 1770035416); d = ff(d, a, b, c, k[9], 12, -1958414417);
      c = ff(c, d, a, b, k[10], 17, -42063); b = ff(b, c, d, a, k[11], 22, -1990404162);
      a = ff(a, b, c, d, k[12], 7, 1804603682); d = ff(d, a, b, c, k[13], 12, -40341101);
      c = ff(c, d, a, b, k[14], 17, -1502002290); b = ff(b, c, d, a, k[15], 22, 1236535329);

      a = gg(a, b, c, d, k[1], 5, -165796510); d = gg(d, a, b, c, k[6], 9, -1069501632);
      c = gg(c, d, a, b, k[11], 14, 643717713); b = gg(b, c, d, a, k[0], 20, -373897302);
      a = gg(a, b, c, d, k[5], 5, -701558691); d = gg(d, a, b, c, k[10], 9, 38016083);
      c = gg(c, d, a, b, k[15], 14, -660478335); b = gg(b, c, d, a, k[4], 20, -405537848);
      a = gg(a, b, c, d, k[9], 5, 568446438); d = gg(d, a, b, c, k[14], 9, -1019803690);
      c = gg(c, d, a, b, k[3], 14, -187363961); b = gg(b, c, d, a, k[8], 20, 1163531501);
      a = gg(a, b, c, d, k[13], 5, -1444681467); d = gg(d, a, b, c, k[2], 9, -51403784);
      c = gg(c, d, a, b, k[7], 14, 1735328473); b = gg(b, c, d, a, k[12], 20, -1926607734);

      a = hh(a, b, c, d, k[5], 4, -378558); d = hh(d, a, b, c, k[8], 11, -2022574463);
      c = hh(c, d, a, b, k[11], 16, 1839030562); b = hh(b, c, d, a, k[14], 23, -35309556);
      a = hh(a, b, c, d, k[1], 4, -1530992060); d = hh(d, a, b, c, k[4], 11, 1272893353);
      c = hh(c, d, a, b, k[7], 16, -155497632); b = hh(b, c, d, a, k[10], 23, -1094730640);
      a = hh(a, b, c, d, k[13], 4, 681279174); d = hh(d, a, b, c, k[0], 11, -358537222);
      c = hh(c, d, a, b, k[3], 16, -722521979); b = hh(b, c, d, a, k[6], 23, 76029189);
      a = hh(a, b, c, d, k[9], 4, -640364487); d = hh(d, a, b, c, k[12], 11, -421815835);
      c = hh(c, d, a, b, k[15], 16, 530742520); b = hh(b, c, d, a, k[2], 23, -995338651);

      a = ii(a, b, c, d, k[0], 6, -198630844); d = ii(d, a, b, c, k[7], 10, 1126891415);
      c = ii(c, d, a, b, k[14], 15, -1416354905); b = ii(b, c, d, a, k[5], 21, -57434055);
      a = ii(a, b, c, d, k[12], 6, 1700485571); d = ii(d, a, b, c, k[3], 10, -1894986606);
      c = ii(c, d, a, b, k[10], 15, -1051523); b = ii(b, c, d, a, k[1], 21, -2054922799);
      a = ii(a, b, c, d, k[8], 6, 1873313359); d = ii(d, a, b, c, k[15], 10, -30611744);
      c = ii(c, d, a, b, k[6], 15, -1560198380); b = ii(b, c, d, a, k[13], 21, 1309151649);
      a = ii(a, b, c, d, k[4], 6, -145523070); d = ii(d, a, b, c, k[11], 10, -1120210379);
      c = ii(c, d, a, b, k[2], 15, 718787259); b = ii(b, c, d, a, k[9], 21, -343485551);

      state[0] = add32(a, state[0]);
      state[1] = add32(b, state[1]);
      state[2] = add32(c, state[2]);
      state[3] = add32(d, state[3]);
    }

    function md5blk(s) {
      var md5blks = [];
      for (var i = 0; i < 64; i += 4) {
        md5blks[i >> 2] = s.charCodeAt(i) + (s.charCodeAt(i + 1) << 8) + (s.charCodeAt(i + 2) << 16) + (s.charCodeAt(i + 3) << 24);
      }
      return md5blks;
    }

    function md51(s) {
      var n = s.length;
      var state = [1732584193, -271733879, -1732584194, 271733878];
      var i;
      for (i = 64; i <= n; i += 64) md5cycle(state, md5blk(s.substring(i - 64, i)));
      s = s.substring(i - 64);
      var tail = new Array(16).fill(0);
      for (i = 0; i < s.length; i++) tail[i >> 2] |= s.charCodeAt(i) << ((i % 4) << 3);
      tail[i >> 2] |= 0x80 << ((i % 4) << 3);
      if (i > 55) {
        md5cycle(state, tail);
        tail = new Array(16).fill(0);
      }
      tail[14] = n * 8;
      md5cycle(state, tail);
      return state;
    }

    function rhex(n) {
      var s = '';
      for (var j = 0; j < 4; j++) s += ('0' + ((n >> (j * 8 + 4)) & 0x0F).toString(16)).slice(-1) + ('0' + ((n >> (j * 8)) & 0x0F).toString(16)).slice(-1);
      return s;
    }

    return md51(unescape(encodeURIComponent(String(input)))).map(rhex).join('');
  }

  function buildSign(data) {
    var plainText = SIGN_SECRET + data.campaign_id + data.model + data.serial_number + data.email + SIGN_SECRET;
    return md5(plainText);
  }

  function showError(errorEl, message) {
    if (!errorEl) return;
    errorEl.textContent = message;
    errorEl.hidden = false;
  }

  function initSection(section) {
    var form = section.querySelector('[data-x3-form-state="form"]');
    var success = section.querySelector('[data-x3-form-state="success"]');
    var errorEl = section.querySelector('[data-x3-form-error]');
    var submitBtn = section.querySelector('[data-x3-form-submit]');
    if (!form || !success) return;

    // Copy buttons
    section.querySelectorAll('[data-x3-coupon-copy]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var row = btn.closest('.x3-form__coupon-code-row');
        var codeEl = row && row.querySelector('[data-x3-coupon-code]');
        if (!codeEl) return;
        var text = codeEl.textContent.trim();
        if (!text || text === 'XXXX-XXXXXX') return;
        var done = function () {
          var original = btn.textContent;
          btn.classList.add('is-copied');
          btn.textContent = 'Copied';
          setTimeout(function () {
            btn.classList.remove('is-copied');
            btn.textContent = original;
          }, 1500);
        };
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(text).then(done).catch(function () {});
        } else {
          var ta = document.createElement('textarea');
          ta.value = text;
          document.body.appendChild(ta);
          ta.select();
          try { document.execCommand('copy'); } catch (e) {}
          document.body.removeChild(ta);
          done();
        }
      });
    });

    form.addEventListener('submit', function (evt) {
      evt.preventDefault();
      if (errorEl) { errorEl.hidden = true; errorEl.textContent = ''; }

      var model = String(((form.querySelector('[data-x3-form-input="model"]') || {}).value) || '').trim();
      var serialNumber = String(((form.querySelector('[data-x3-form-input="serial"]') || {}).value) || '').trim();
      var email = String(((form.querySelector('[data-x3-form-input="email"]') || {}).value) || '').trim();

      if (!model || !serialNumber) {
        showError(errorEl, '機種とシリアルナンバーを入力してください。');
        return;
      }

      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        showError(errorEl, 'メールアドレスの形式を確認してください。');
        return;
      }

      var apiUrl = (section.getAttribute('data-api-url') || '').trim() || API_URL_FALLBACK;
      submitBtn && submitBtn.setAttribute('disabled', 'disabled');

      // eslint-disable-next-line no-console
      console.log('[x3-coupon-form] submit', { apiUrl: apiUrl, model: model, serial: serialNumber, email: email });

      var showSuccess = function (coupons) {
        var filledCount = 0;
        section.querySelectorAll('[data-coupon-key]').forEach(function (li) {
          var key = li.getAttribute('data-coupon-key');
          var code = coupons && coupons[key];
          if (!code) return;
          var codeEl = li.querySelector('[data-x3-coupon-code]');
          if (codeEl) {
            codeEl.textContent = code;
            filledCount += 1;
          }
        });

        if (!filledCount) {
          showError(errorEl, 'クーポンコードを取得できませんでした。時間をおいて再度お試しください。');
          return;
        }

        form.hidden = true;
        success.hidden = false;
        // Scroll to top of section so user sees the success
        try {
          section.scrollIntoView({ behavior: 'smooth', block: 'start' });
        } catch (e) {}
      };



      var requestBody = {
        model: model,
        serial_number: serialNumber,
        email: email,
        campaign_id: CAMPAIGN_ID
      };
      requestBody.sign = buildSign(requestBody);

      fetch(apiUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(requestBody)
      })
        .then(function (res) {
          if (!res.ok) throw new Error('HTTP ' + res.status);
          return res.json();
        })
        .then(function (data) {
          submitBtn && submitBtn.removeAttribute('disabled');

          if (!data || Number(data.code) !== 200) {
            showError(errorEl, (data && data.message) || '認証に失敗しました。入力内容をご確認ください。');
            return;
          }

          var payload = data.data || {};
          if (payload.is_expired) {
            showError(errorEl, 'キャンペーン期間が終了しました。');
            return;
          }

          if (!payload.x3_l4k_code || !payload.x3_code) {
            showError(errorEl, 'クーポンコードを取得できませんでした。時間をおいて再度お試しください。');
            return;
          }

          showSuccess({
            x3_l4k_code: payload.x3_l4k_code,
            x3_code: payload.x3_code
          });
        })
        .catch(function (err) {
          submitBtn && submitBtn.removeAttribute('disabled');
          showError(errorEl, '通信に失敗しました。時間をおいて再度お試しください。');
          // eslint-disable-next-line no-console
          console.error('[x3-coupon-form]', err);
        });
    });
  }

  function init() {
    document.querySelectorAll('[data-x3-form-section]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
